import { CNHealthAgent } from './cnhealthagent';

export class CNDoctor extends CNHealthAgent {

    private propMapping = {
    };

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.SNUser.CNUser.CNHealthAgent.CNDoctor';
        this.loaded.subscribe(myself => {
            for (const key of Object.keys(this.properties)) {
                let propKey = key.toLowerCase();
                if (key in this.propMapping) {
                    propKey = this.propMapping[key];
                }
                Object.defineProperty(this, propKey, {
                  get: () => this.properties[key],
                  set: (value: any) => {
                    if (this.properties[key] !== value) {
                      this.properties[key] = value;
                    }
                  },
                });
              }
        });
    }

    public clone(): any {
        return new CNDoctor();
    }
}
